export function getPartyAttribuites(
  activeAttributes = [],
  {
    caseTypeId,
    legalPositionId, // casePartyRole
    partyTypeId = null,
  } = {},
) {
  const result = {
    partyTypesList: [],
    partyRolesList: [],
  };

  if (caseTypeId == null || legalPositionId == null || !Array.isArray(activeAttributes) || activeAttributes.length === 0) {
    return result;
  }

  // partyTypesList
  const { typesMap, rolesMap } = activeAttributes.reduce(
    (acc, attr) => {
      if (attr.caseTypeId !== caseTypeId || attr.legalPositionId !== legalPositionId) {
        return acc;
      }

      if (attr.partyTypeId != null && !acc.typesMap.has(attr.partyTypeId)) {
        acc.typesMap.set(attr.partyTypeId, {
          id: attr.partyTypeId,
          name: attr.partyTypeName,
        });
      }

      if (
        partyTypeId != null &&
        attr.partyTypeId === partyTypeId &&
        attr.partyRoleId != null &&
        !acc.rolesMap.has(attr.partyRoleId)
      ) {
        acc.rolesMap.set(attr.partyRoleId, {
          id: attr.partyRoleId,
          name: attr.partyRoleName,
          isMultiple: !!attr.isMultiple,
          isOptional: !!attr.isOptional,
        });
      }
      return acc;
    },
    { typesMap: new Map(), rolesMap: new Map() },
  );

  result.partyTypesList = Array.from(typesMap.values());
  result.partyRolesList = partyTypeId != null ? Array.from(rolesMap.values()) : [];

  return result;
}
